$j(document).ready(function () {

	if (window.location.href.indexOf("produkt-berater") > -1) {

		var step = 1;
		var tags = [];

		$j("#berater .step.result.animate__animated").hide();

		const beraterNav = document.querySelector('#berater .berater-navigation .berater-nav');

		beraterNav.addEventListener('animationend', () => {
			$j(beraterNav).removeClass("animate__fadeInUp");
		});

		$j(beraterNav).addClass('muted');

		function showStep01() {
			$j(beraterNav).addClass('muted');
			$j("#berater .step.step02").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step02").hide();

			$j("#berater .step.step01").css('display', 'grid').addClass('animate__pulse');
			$j("#berater .animation-wrapper .grid-wrapper.step01").css('display', 'grid').addClass('animate__slideInRight');
			step = 1;
		};

		function showStep02() {
			$j("#berater .step.step01").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step01").hide();

			$j("#berater .step.step03").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step03").hide();

			$j("#berater .step.step02").css('display', 'grid').addClass('animate__pulse');
			$j("#berater .animation-wrapper .grid-wrapper.step02").css('display', 'grid').addClass('animate__slideInRight');

			$j(beraterNav).removeClass('muted');
			$j(beraterNav).addClass("animate__fadeInUp");
			step = 2;
		};

		function showStep03() {
			$j(beraterNav).removeClass('muted');
			$j("#berater .step.step02").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step02").hide();

			$j("#berater .step.step04").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step04").hide();

			$j("#berater .step.step03").css('display', 'grid').addClass('animate__pulse');
			$j("#berater .animation-wrapper .grid-wrapper.step03").css('display', 'grid').addClass('animate__slideInRight');
			$j(beraterNav).addClass("animate__fadeInUp");
			step = 3;
		};

		/**
		function showStep04() {
			$j(beraterNav).removeClass('muted');
			$j("#berater .step.step03").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step03").hide();

			$j("#berater .step.step04").css('display', 'grid').addClass('animate__pulse');
			$j("#berater .animation-wrapper .grid-wrapper.step04").css('display', 'grid').addClass('animate__slideInRight');
			$j(beraterNav).addClass("animate__fadeInUp");
			step = 4;
		};
		 */

		function showResult() {
			var urlParam = tags.join("+");
			var collectionURL = "../collections/shop/" + urlParam;
			console.log(collectionURL);
			$j("section[data-custom-class='page-banner'] .page-hero.berater-start").hide();
			$j("section[data-custom-class='page-banner'] .page-hero.berater-stop").show();
			$j("#berater .step.step03").hide();
			$j("#berater .animation-wrapper .grid-wrapper.step03").hide();
			$j("#berater .berater-navigation").hide();
			$j("#berater .step.result").show();

			$j([document.documentElement, document.body]).animate({
				scrollTop: 0
			}, 500, function () {
				$j(".page-hero.berater-stop h1.animate__animated").addClass('animate__heartBeat');
			});

			$j("#index-berater-result").load(collectionURL + " #berater-result", function () {
				$j("#berater-result .product-item.product-item--vertical").addClass("1/5--desk");
				$j("#berater-result .product-item.product-item--vertical").removeClass("1/4--desk");
				$j("#berater-result .collection .collection__toolbar").hide();
				$j("#berater-repeat").css('display', 'flex');
			})
		};

		$j('#berater #auszeit').click(function () {
			tags.push("auszeit-suche");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			showStep02();
		});
		$j('#berater #experiment').click(function () {
			tags.push("experimentierfreude");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			showStep02();
		});
		$j('#berater #familie').click(function () {
			tags.push("familienmensch");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			else {
				$j([document.documentElement, document.body]).animate({
					scrollTop: $j("#berater").offset().top - 80
				}, 500);
			}
			showStep02();
		});
		$j('#berater #beschaeftigt').click(function () {
			tags.push("vielbeschaeftigt");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			} else {
				$j([document.documentElement, document.body]).animate({
					scrollTop: $j("#berater").offset().top - 80
				}, 500);
			}
			showStep02();
		});
		$j('#berater #perhand').click(function () {
			tags.push("per-hand");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			showStep03();
		});
		$j('#berater #knopfdruck').click(function () {
			tags.push("knopfdruck");
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			showStep03();
		});
		$j('#berater #kraeftig').click(function () {
			tags.push("kraeftig");

			showResult();
		});
		$j('#berater #mild').click(function () {
			tags.push("mild");
			showResult();
		});
		$j('#berater #klassisch').click(function () {
			tags.push("klassisch");
			showResult();
		});
		$j('#berater #neugierig').click(function () {
			tags.push("neugierig");
			showResult();
		});
		$j('#berater #anspruchsvoll').click(function () {
			tags.push("anspruchsvoll");
			showResult();
		});

		$j('#berater .berater-navigation .berater-nav').click(function () {
			tags.pop();
			if (window.innerWidth < 390) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 150
				}, 500);
			}
			else if (window.innerWidth < 1000) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 130
				}, 500);
			}
			else if (window.innerWidth < 1110) {
				$j('html, body').animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);
			}
			if (step == 2) {
				showStep01();
			} else if (step == 3) {
				showStep02();
			} else if (step == 4) {
				showStep03();
			}
		});

		$j('#berater-repeat button').click(function () {
			tags = [];
			$j("#berater .step.result").hide();
			$j("#index-berater-result #berater-result").remove();
			$j(".berater-page .page-hero.berater-stop").hide();
			$j(".berater-page .page-hero.berater-start").show();
			$j("#berater-repeat").hide();
			showStep01();
			$j("#berater .berater-navigation").show();
			$j(".page-hero.berater-stop h1.animate__animated").removeClass('animate__heartBeat');

			var topPosition = $j('header.header').height() + $j('nav.nav-bar').height() + 60;

			$j([document.documentElement, document.body]).animate({
				scrollTop: $j("#berater").offset().top - topPosition
			}, 500);
		});
	}
});
